import React from "react";

const CerdasBangsa = () => {
  return (
    <div className="bg-gray-100 min-h-screen py-10">
      <div className="container mx-auto px-6 lg:px-20">
        <div className="bg-white shadow-lg rounded-2xl overflow-hidden">
          <div className="relative">
            <img
              src="/images/cerdasbangsa1.jpeg"
              alt="Sekolah Cerdas Bangsa"
              className="w-full h-[500px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-900 opacity-70"></div>
            <div className="absolute bottom-4 left-6 text-white">
              <h1 className="text-3xl lg:text-5xl font-bold text-white">Sekolah Cerdas Bangsa</h1>
              <p className="text-lg lg:text-xl mt-2">Mencetak Generasi Emas dengan Nilai-Nilai Kehidupan dan takut akan TUHAN</p>
            </div>
          </div>
          <div className="p-8 lg:p-16">
            <section className="mb-10">
              <h2 className="text-2xl lg:text-3xl font-semibold text-gray-800 mb-4">Tentang Sekolah Kami</h2>
              <p className="text-gray-600 text-lg leading-relaxed">
              Yayasan Cerdas Bangsa Merupakan yayasan yang didirikan oleh Bapak Hendrawan selaku Ketua Yayasan. Yayasan Cerdas Bangsa telah mendirikan TK Cerdas Bangsa pada Tahun 2006 dan SD Cerdas Bangsa pada tahun 2007. Yayasan Cerdas Bangsa Berdomisili di Cibinong Bogor.

TK Cerdas Bangsa didirikan pada tanggal 25 Juni 2006 berdasarkan izin diknas Kabupaten Bogor No. 421.1/2160-Disdik/2007 Oktober 2008 dengan akreditasi B. Sedangkan SD Cerdas Bangsa didirikan Pada tanggal 01 Juli 2007, berdasarkan izin diknas Kabupaten Bogor Nomor : 421.2/243-Disdik/2010. Dengan Akreditasi A.   </p>
           <br/>
           <p className="text-gray-600 text-lg leading-relaxed">Direktur Yayasan setiap tahun memberikan dana beasiswa kepada jemaat yang tidak mampu untuk sekolah di luar. Setiap tahun yang di bantu semakin banyak dan dana yang di butuhkan pun semakin besar. Akhirnya Yayasan memiliki ide bagaimana jika mendirikan sekolah sendiri supaya dana yang cukup besar ini tidak perlu keluar ke sekolah lain.

Maka didirikanlah sekolah TK Cerdas Bangsa pada tahun 2006 dibawah naungan Yayasan Cerdas Bangsa yang di ketuai oleh bapak Hendrawan. Setahun berjalan orang tua yang lulus menginginkan anaknya lanjut di Sekolah Dasar dengan Yayasan yang sama. Maka didirikan pula SD Cerdas Bangsa pada tahun 2007.</p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl lg:text-3xl font-semibold text-gray-800 mb-4">Visi & Misi SD</h2>
              <div className="grid lg:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-xl font-semibold text-gray-700 mb-2">Visi</h3>
                  <p className="text-gray-600 text-xl leading-relaxed">
                  Terwujudnya Sekolah yang unggul dalam berakhlak mulia, berprestasi, mandiri, dan Nasionalis.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-700 mb-2">Misi</h3>
                  <ul className="list-disc pl-6 text-gray-600 leading-relaxed">
                  <li>Menumbuhkan penghayatan dan pengalaman ajaran agama yang dianut.</li>
<li>Mengembangkan kurikulum sekolah sesuai dengan standar nasional.</li>
<li>Mengembangkan proses pembelajaran yang aktif, kreatif, dan inovatif.</li>
<li>Mengembangkan sistem penilaian autentik melalui pendekatan scientifik.</li>
<li>Meningkatkan kualitas pendidik dan tenaga pendidik.</li>
<li>Meningkatkan prestasi baik akademik maupun non akademik.</li>
                  </ul>
                </div>
              </div>
            </section>
            <section className="mb-10">
              <h2 className="text-2xl lg:text-3xl font-semibold text-gray-800 mb-4">Visi & Misi TK</h2>
              <div className="grid lg:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-xl font-semibold text-gray-700 mb-2">Visi</h3>
                  <p className="text-gray-600 text-xl leading-relaxed">
                  Membangun generasi yang beriman, berkarakter, cerdas dan berkharisma </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-700 mb-2">Misi</h3>
                  <ul className="list-disc pl-6 text-gray-600 leading-relaxed">
                  <li>Meningkatkan rasa cinta kepada Tuhan, diri sendiri dan sesama</li>
<li>Menjadikan generasi yang berkarakter</li>
<li>Menumbuhkembangkan kreatifitas, imajinasi dan kognitif</li>
<li>Menghasilkan generasi yang senantiasa memancarkan kemuliaan Tuhan</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl lg:text-3xl font-semibold text-gray-800 mb-4">Fasilitas Kami</h2>
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="bg-gray-50 rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-700">Ruang Kelas Modern</h3>
                  <p className="text-gray-600 mt-2">
                    Dilengkapi dengan teknologi canggih dan suasana yang nyaman untuk mendukung
                    pembelajaran interaktif.
                  </p>
                </div>
                <div className="bg-gray-50 rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-700">Laboratorium Lengkap</h3>
                  <p className="text-gray-600 mt-2">
                    Laboratorium sains, komputer, dan bahasa yang mendukung eksplorasi pengetahuan siswa.
                  </p>
                </div>
                <div className="bg-gray-50 rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-700">Area Olahraga</h3>
                  <p className="text-gray-600 mt-2">
                    Fasilitas olahraga lengkap untuk mengembangkan kebugaran fisik dan jiwa kompetitif siswa.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl lg:text-3xl font-semibold text-gray-800 mb-4">Mengapa Memilih Kami?</h2>
              <ul className="list-disc pl-6 text-gray-600 leading-relaxed">
                <li>Lingkungan belajar yang aman dan inklusif.</li>
                <li>Kurikulum berbasis kompetensi yang relevan dengan kebutuhan zaman.</li>
                <li>Program ekstrakurikuler yang beragam untuk mengembangkan minat dan bakat siswa.</li>
                <li>Komitmen untuk membangun karakter unggul pada setiap siswa.</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl lg:text-3xl font-semibold text-gray-800 mb-4">Hubungi Kami</h2>
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="bg-gray-50 rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-700">Narahubung TK</h3>
                  <p className="text-gray-600 mt-2">Nama: Ibu Sondang  
                  </p>
                  <p className="text-gray-600">Telepon: 0813-1676-9191</p>
                </div>
                <div className="bg-gray-50 rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-700">Narahubung SD</h3>
                  <p className="text-gray-600 mt-2">Nama: Ibu Tiarma </p>
                  <p className="text-gray-600">Telepon: 0813-1691-1696</p>
                </div>
                <div className="bg-gray-50 rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-700">Narahubung SD</h3>
                  <p className="text-gray-600 mt-2">Nama: Ibu Novi </p>
                  <p className="text-gray-600">Telepon: 0896-0580-4229</p>
                </div>
              </div>
            </section>
            {/* Visit Website Button */}
            <section className="text-center mt-12">
              <a
                href="https://sekolahcerdasbangsa.sch.id"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block no-underline bg-green-600 text-white text-lg font-medium w-auto  px-6 py-3 rounded-xl shadow-md hover:bg-green-700 transition duration-200"
              >
                Kunjungi Website Kami
              </a>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CerdasBangsa;
